import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import BackButtonIcon from "../../../assets/icons/BackButtonIcon";
import TopCard from "../../../components/common/TopCard";
import SidebarLayout from "../../../layouts/SidebarLayout";

import { UploadOutlined } from "@ant-design/icons";
import { DatePicker, Form, Input, Select, Upload } from "antd";
import AddIcon from "../../../assets/icons/AddIcon";
import DocumentIcon from "../../../assets/icons/DocumentIcon";
import AssignProductModal from "../../../components/Businesses/AssignProductModal";
import useModal from "../../../hooks/useModal";

const { Option } = Select;

export default function AddNewRequests() {
  const navigate = useNavigate();
  const { open, handleOpen, handleClose } = useModal();

  const onFinish = (values: any) => {
    console.log("Success:", values);
  };

  return (
    <SidebarLayout title="Add New Business">
      {open.type === "ADD" && (
        <AssignProductModal open={open.open} handleClose={handleClose} />
      )}
      <TopCard
        leftChildren={
          <Button
            className="normal-dark-button"
            icon={<BackButtonIcon />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        }
      >
        <Button type="primary">Submit</Button>
      </TopCard>

      <div className="grid grid-cols-3 gap-4">
        <div className="col-span-2">
          <Form
            layout="vertical"
            onFinish={onFinish}
            className="w-full max-w-4xl bg-white p-6 rounded-2xl"
          >
            {/* Basic Info */}

            <div className="bg-[#F0F3F9] p-4 text-lg font-semibold mb-4 rounded-[6px] h-[42px] text-display-body text-base flex items-center justify-start gap-2 flex-shrink-0">
              Basic Info
            </div>
            <div className="grid grid-cols-2 gap-4">
              <Form.Item label="Business Logo" name="businessLogo">
                <Upload beforeUpload={() => false}>
                  <Button icon={<UploadOutlined />}>Browse file</Button>
                </Upload>
              </Form.Item>

              <Form.Item
                label="Company Name"
                name="companyName"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter Company name" />
              </Form.Item>

              <Form.Item
                label="Business Email"
                name="businessEmail"
                rules={[{ type: "email" }]}
              >
                <Input placeholder="Enter business email" />
              </Form.Item>

              <Form.Item label="Mobile Number" name="mobileNumber">
                <Input placeholder="+880 XXXX XXXX XXX" />
              </Form.Item>

              <Form.Item label="Company Location" name="companyLocation">
                <Select placeholder="Select">
                  <Option value="dhaka">Dhaka</Option>
                  <Option value="chittagong">Chittagong</Option>
                </Select>
              </Form.Item>

              <Form.Item label="Full Address" name="fullAddress">
                <Input placeholder="Enter full address" />
              </Form.Item>
            </div>

            {/* Documents */}

            <div className="bg-[#F0F3F9] p-4 mt-4 text-lg font-semibold mb-4 rounded-[6px] h-[42px] text-display-body text-base flex items-center justify-start gap-2 flex-shrink-0">
              Documents
            </div>
            <div className="grid grid-cols-2 gap-4">
              <Form.Item label="TIN Certificate" name="tinCertificate">
                <Upload beforeUpload={() => false}>
                  <Button icon={<UploadOutlined />}>Browse file</Button>
                </Upload>
              </Form.Item>

              <Form.Item label="Issue Date" name="tinIssueDate">
                <DatePicker className="w-full" />
              </Form.Item>

              <Form.Item label="Expire Date" name="tinExpireDate">
                <DatePicker className="w-full" />
              </Form.Item>
              <br />

              <Form.Item label="Trade License" name="tradeLicense">
                <Upload beforeUpload={() => false}>
                  <Button icon={<UploadOutlined />}>Browse file</Button>
                </Upload>
              </Form.Item>

              <Form.Item label="Issue Date" name="tradeIssueDate">
                <DatePicker className="w-full" />
              </Form.Item>

              <Form.Item label="Expire Date" name="tradeExpireDate">
                <DatePicker className="w-full" />
              </Form.Item>
            </div>

            {/* Bank Details */}

            <div className="bg-[#F0F3F9] p-4 mt-4 text-lg font-semibold mb-4 rounded-[6px] h-[42px] text-display-body text-base flex items-center justify-start gap-2 flex-shrink-0">
              Bank Details
            </div>
            <div className="grid grid-cols-2 gap-4">
              <Form.Item label="Bank Name" name="bankName">
                <Input placeholder="Enter bank name" />
              </Form.Item>

              <Form.Item label="Account Number" name="accountNumber">
                <Input placeholder="12345XXXXXXXX2345" />
              </Form.Item>

              <Form.Item label="Branch Name" name="branchName">
                <Input placeholder="Enter bank branch" />
              </Form.Item>
            </div>
          </Form>
        </div>
        <div className="col-span-1">
          <div className="mb-4">
            <div
              className="flex justify-between items-center w-80 h-[42px] bg-[#F0F3F9] shadow-sm rounded-lg pl-6 pr-4"
              style={{ border: "1px solid #E9EFF6" }}
            >
              <h5 className="text-lg font-semibold flex-shrink-0">Products</h5>

              <Button
                className="text-base !bg-transparent !border-none !shadow-none !text-[#FE7235] hover:!text-[#FE7235] hover:!bg-transparent focus:!outline-none focus:!ring-0 flex items-center justify-center gap-2 flex-shrink-0"
                type="default"
                icon={<AddIcon />}
              >
                Add
              </Button>
            </div>

            <div className="py-4 mt-8 flex justify-center">
              <DocumentIcon />
            </div>
          </div>

          <div className="mb-4">
            <div
              className="flex justify-between items-center w-80 h-[42px] bg-[#F0F3F9] shadow-sm rounded-lg pl-6 pr-4 mt-8"
              style={{ border: "1px solid #E9EFF6" }}
            >
              <h5 className="text-lg font-semibold flex-shrink-0">Logs</h5>
            </div>

            <div className="py-4 mt-8 flex justify-center">
              <DocumentIcon />
            </div>
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
}
